module.exports = __webpack_public_path__ + "img/calendar.e204f825.png";